import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitEarlyAccess = async (formData) => {
  try {
    // Convert camelCase to snake_case for backend
    const backendData = {
      full_name: formData.fullName,
      email: formData.email,
      company: formData.company,
      role: formData.role,
      message: formData.message
    };
    
    const response = await axios.post(`${API}/early-access`, backendData);
    return response.data;
  } catch (error) {
    console.error('Error submitting early access request:', error);
    throw error;
  }
};

export const getEarlyAccessSubmissions = async () => {
  try {
    const response = await axios.get(`${API}/early-access`);
    return response.data;
  } catch (error) {
    console.error('Error fetching early access requests:', error);
    throw error;
  }
};